import { RCCIIconTypes } from "react-common-components";
import { AppIconTypes } from "src/components/AppIcons/interface";

interface IAuthContextProps {
    administrator: boolean;
    superUser: boolean;
    user: IUser;
    permissions: IPermissions[];
    businessGroup: IBusinessGroup;
    company: ICompany;
    defaultDashboard: string | null;
    homePage: string;
    scheduleRestriction: boolean;
    systemNotifications: ISystemNotifications[];
    signIn: ({email, password, executeBeforeTFA}: { email: string, password: string, executeBeforeTFA?: Function, remember: boolean, executeAfterTermsUseAccepted?: Function}) => Promise<void>;
    signOut: () => void;
    updateCompanyLogged: (eftba002: ICompany, eftba001: IBusinessGroup, token: string, eftbb001: IPermissions[], userConfig: IUserConfig, administrator: boolean, scheduleRestriction: boolean, tokenExpirationHours: number) => void;
    updateUserImage: (efa005Imagem: string) => void;
    updateUserNameAndTreatment: (efa005Nome: string, efa005Tratamento?: string) => void;
    updateDefaultDashboard: (dashboardId: string | null) => void;
    updateHomePage: (page: string) => void;
    updateCompanyName: (efa002Fantasia: string) => void;
    updateCompanyImage: (efa002Imagem: string) => void;
    checkIfHasPermission: (path: string) => boolean;
    checkIfHasSpecificPermission: (path: string, permission: PermissionEnum) => boolean;
    checkIfHasContractPermission: (path: string) => boolean;
}

export interface ISystemNotifications{
    efn001Id: number;
    efn001Msgsimples: string;
    efn001Msgcompleta: string;
    efn001Tipo: number;
    efn001Dtinicial: Date;
    efn001Dtfinal: Date;
    efn001Mostrar: number;
  }

export interface IUserConfig{
    efa105Painelindicadores: string | null;
    efa105Painelacoes: string | null;
    efa105Painelriscos: string | null;
    efa105Painelocorrencias: string | null;
    efa105Painelauditorias: string | null;
    efa105Painelokr: string | null;
    efa105Dashboard: string | null;
    efa105Painelreunioes: string | null;
}

interface IUser {
    efa005Id: number;
    efa005Nome: string;
    efa005Email: string;
    efa005Usuario: string;
    efa005Imagem: string;
    efa005ValidaIP: string;
    efa005Paginicial: number;
    efa005Tratamento: string;
}

export enum PermissionEnum{
    NOT_DEFINED = -1,
    NO_ACCESS = 0,
    CREATE_UPDATE_DELETE = 1,
    CREATE_UPDATE = 2,
    VIEW = 3
}

export interface IPermissions{
    id: number;
    path: string;
    permission: PermissionEnum;
    contractHasAccess: boolean;
}

export interface IMenuChild extends Omit<IMenu, "children">{ }

export interface IMenu{
    efb005Descricao: string;
    efb005DescricaoSimplificada?: string;
    efb001Codigo: string;
    internalAction?: boolean;
    systemConfigs?: boolean;
    icon?: RCCIIconTypes;
    img?: AppIconTypes;
    children: Array<IMenuChild>;
    putSeparatorBeforeSidebarItem?: boolean;
}

export interface IBusinessGroup{
    efa001Id: number;
    efa001Fantasia: string;
}

export interface ICompany{
    efa002Id: number;
    efa002Fantasia: string;
    efa002Imagem?: string;
}

export interface ICredentials {
    token: string;
    administrator: boolean;
    superUser: boolean;
    eftba001: IBusinessGroup;
    eftba002: ICompany;
    eftba005: IUser; 
}

export interface IRefModalTFA{
    openTFAModal: (efa005Id: number, onCallback: Function) => void;
}

export default IAuthContextProps;
